import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class LogMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: LogMetaModule,
            providers: [
                providePageMeta({
                    title: 'Logs',
                    translationKey: 'page_logs',
                    permission: 'Logs.View',
                    routerLink: '/logs',
                    sidebarSection: 'Monitoring',
                    icon: 'notes',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                    priority: 4,
                }),
                providePageMeta({
                    title: 'Robot Logs',
                    translationKey: 'page_logs',
                    permission: 'Logs.View',
                    routerLink: '/robots/:id/logs',
                    type: 'Breadcrumb',
                    parentRoute: '/robots',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                }),
                providePageMeta({
                    title: 'Job Logs',
                    translationKey: 'page_logs',
                    permission: 'Logs.View',
                    routerLink: '/jobs/:id/logs',
                    type: 'Breadcrumb',
                    parentRoute: '/jobs',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                }),
            ],
        };
    }
}
